export default __webpack_public_path__ + "static/media/yt.db71201b.svg";